import { render } from "./OffCanvas.vue?vue&type=template&id=985805ba&scoped=true"
import script from "./OffCanvas.vue?vue&type=script&lang=js"
export * from "./OffCanvas.vue?vue&type=script&lang=js"

import "./OffCanvas.vue?vue&type=style&index=0&id=985805ba&scoped=true&lang=css"

import exportComponent from "F:\\PWAs\\urbanquater-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-985805ba"]])

export default __exports__